import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import apiClient from '../../api';

function ConfirmEmail() {
  const { token } = useParams();
  const [message, setMessage] = useState('Confirming your email...');
  const [hasRequested, setHasRequested] = useState(false);

  useEffect(() => {
    if (token && !hasRequested) {
      setHasRequested(true);
      apiClient.get(`/confirm/${token}`)
        .then((response) => {
          setMessage(response.data.message || 'Email confirmed successfully!');
        })
        .catch((error) => {
          setMessage(error.response?.data?.detail || 'Error confirming email. Invalid or expired link.');
        });
    }
  }, [token, hasRequested]);

  return (
    <div>
      <h2>Email Confirmation Status</h2>
      <p>{message}</p>
      {message.toLowerCase().includes('successfully') && (
        <p>You can now log in.</p>
      )}
    </div>
  );
}

export default ConfirmEmail;
